'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var colors = require('../../../constants/colors.js');
var sizes = require('../../../constants/sizes.js');
var Spinner = require('../../Spinner/src/Spinner.js');
var Button_module = require('../styles/Button.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description A Button triggers an action or an event
 *
 * @component
 * @example
 * ```jsx
 * <Button variant="primary" color="green" disabled block>
 *   Primary <Icon size="s" icon={<MenuIcon />} />
 * </Button>
 * ```
 */
const Button = React__namespace.forwardRef((props, ref) => {
    const { variant, color, size, block, loading, disabled, active, type = 'button', className, children, ...restProps } = props;
    const cx = reactUtils.useStyles(Button_module.default);
    const classNames = cx(className, 'container', {
        block,
        loading,
        active,
        [`size-${size}`]: size,
        [`disabled-${variant}`]: disabled || loading,
        [`color-${color}-${variant}`]: true,
    });
    const textClassNames = cx('text');
    return (
    // eslint-disable-next-line react/button-has-type
    React__namespace.createElement("button", { "data-qa": "Button", ref: ref, type: type, className: classNames, disabled: disabled || loading, ...restProps },
        React__namespace.createElement("span", { className: textClassNames }, children),
        loading && React__namespace.createElement(Spinner.Spinner, { className: cx('spinner') })));
});
Button.defaultProps = {
    variant: 'outlined',
    color: colors.COLORS.DARK,
    size: sizes.CONTAINER_SIZES.S44,
    type: 'button',
};
Button.displayName = 'Button';

exports.Button = Button;
//# sourceMappingURL=Button.js.map
